import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { DrugSearchAjaxCall } from "../../Apis/AuthApiServices";
import {
  loadingDrugSearchAjax,
  setDrugSearchAjax,
} from "../Slice/DrugSearchAjaxSlice";

function* onLoadDrugSearchAjaxAsync({ payload }: any) {
  const params = new URLSearchParams();
  params.append("drugName", payload.drugName);
  try {
    const result: AxiosResponse = yield DrugSearchAjaxCall(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setDrugSearchAjax({
          DrugSearchAjaxData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setDrugSearchAjax({
          DrugSearchAjaxData: [],
          error: true,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setDrugSearchAjax({
        DrugSearchAjaxData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadDrugSearchAjax() {
  yield takeLatest(loadingDrugSearchAjax.type, onLoadDrugSearchAjaxAsync);
}

const DrugSearchAjaxSaga = [fork(onLoadDrugSearchAjax)];
export default DrugSearchAjaxSaga;
